const orginal_state={
    count:0
}

const notificationReducer = (state = orginal_state, action) => {
    switch(action.type) {
        case "UPDATE_NOTIFICATION": {
            return {...state, count: action.counts}
        }
        case "CLEAR_NOTIFICATION": {
            return {...state, count: 0}
        }
        default: {
            return state;
        }
    }
}

export default notificationReducer